import React, { ReactNode } from 'react';
import { Modifier } from '../../../../../../lib/bemUtils/Modifier';
import bem from '../../../../../../lib/bemUtils/bem';

type FormsComboboxMultiSelectListProps = { labelId: string; modifier?: Modifier<'margin-top'>; children: ReactNode[] };

export function FormsComboboxMultiSelectList({ labelId, modifier, children }: FormsComboboxMultiSelectListProps) {
  return (
    <ul className={bem('forms-combobox-multiselect__list', modifier)} aria-labelledby={labelId}>
      {children}
    </ul>
  );
}
